import { HttpClient } from './client'

/**
 * make http client
 * @param {fetch} fetchApi
 * @param {String} baseUrl
 * @param {String} channel
 * @param {String} clientId
 *
 * @returns {HttpClient}
 */
const factory = (fetchApi, baseUrl, channel, clientId) => {
  return new HttpClient(
    fetchApi, baseUrl, channel, clientId
  )
}

const plugin = (Vue, options = {}) => {
  const { fetch, baseUrl, channel, clientId } = options

  const client = factory(fetch, baseUrl, channel, clientId)

  Object.defineProperty(Vue.prototype, '$http', {
    get () {
      return client
    }
  })
}

export { factory, plugin }
